import {apiFuns} from "sw-hic"
let {genStandard} = apiFuns
const api = {
  OutMedicalRecord: genStandard("outMedicalRecord", "/api/ip"),
  Hospitalization: genStandard("hospitalization", "/api/ip"),
}
export default api;